import { parse } from "graphql";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { getGraphQLClient, handleSecureAjaxError } from "@limitless/portal";
import { FIND_MESSAGE } from "../../../portal/apis/queries/MessageQueries";
export const findExpertMessageList = (criteria, callback) => {
  const log = pilog.getLogger("dashboardRatingListActions findRatedMessagesForExpert");
  const graphQLClient = getGraphQLClient();
  const {
    group,
    page,
    count,
    filters,
    sort
  } = criteria;
  const searchCriteria = {
    groups: group,
    page,
    count,
    filters,
    sort
  };
  const {
    query,
    variables
  } = getFindRatingMessagesQuery(searchCriteria);
  graphQLClient.query({
    query,
    variables,
    fetchPolicy: "no-cache"
  }).then(response => {
    const messages = response.data.findRatedMessagesForExpert;
    log.debug({
      messages
    });
    if (messages) {
      callback(messages);
    } else {
      callback({
        hasError: true
      });
    }
  }).catch(error => {
    handleSecureAjaxError(error, "ExpertRatingMessage findRatedMessagesForExpert");
    callback({
      hasError: true,
      error
    });
  });
};
const CRITERIA_MAP = {
  filters: {
    type: ", $filters: [FindRatedMessagesFilter]",
    param: ", filters: $filters"
  },
  sort: {
    type: ",$sort:[FindRatedMessagesForExpertSortInput]",
    param: ",sort:$sort"
  }
};
export const getFindRatingMessagesQuery = searchCriteria => {
  const {
    groups = [],
    count,
    page,
    filters,
    sort
  } = searchCriteria;
  let types = " $messagesPerPage:Int, $page:Int ";
  let params = "messagesPerPage:$messagesPerPage, page:$page";
  const variables = {
    messagesPerPage: count,
    page
  };
  if (filters.length !== 0) {
    types += CRITERIA_MAP.filters.type;
    params += CRITERIA_MAP.filters.param;
    variables.filters = filters;
  }
  if (sort.length !== 0) {
    types += CRITERIA_MAP.sort.type;
    params += CRITERIA_MAP.sort.param;
    variables.sort = sort;
  }
  if (groups.value !== "all") {
    types += ",$tenantName: String, $groupName: String ";
    params += ",tenantName: $tenantName, groupName: $groupName ";
    variables.tenantName = groups.tenantName;
    variables.groupName = groups.value;
  }
  const query = parse(`
    query findRatedMessagesForExpert(${types}) {
        findRatedMessagesForExpert(${params}) {
            expertRatingInfo {
                rating
                ratingMessagesCount
              }
              ratedMessages {
                totalPages
                messagesPerPage
                currentPage
                messages {
                  custRating
                  customerScoreUpdated
                  date
                  groupName
                  displayName
                  includedInRating
                  messageId
                  reviewCompleteDate
                  reviewScore
                  tenantName
                  ratingType
                  isGenaiReview
                }
                count
              }
        }
    }
    `);
  return {
    query,
    variables
  };
};
export const fetchExpertRatingMessage = (messageId, callback) => {
  const graphQLClient = getGraphQLClient();
  graphQLClient.query({
    query: FIND_MESSAGE,
    variables: {
      messageId
    },
    fetchPolicy: "no-cache"
  }).then(response => {
    callback(response.data.findMessage);
  }).catch(error => {
    handleSecureAjaxError(error, "MessageActions fetchExpertMessage");
    callback({
      hasError: true,
      error
    });
  });
};